<template>
  <div v-if="show"
       class="content--sinoreg page--habilitarNascimento">
    <header-blue class="headerBlueEdicao">
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <b-col sm="3"
                 class="habilitacaoTitle">
            <icon-svg icon="engagement"
                      class="icon--md icons--white typeIcon" />
            E-Habilitação
          </b-col>
          <b-col sm="9"
                 class="headerEditHabilitacao">
            <b-row>
              <HeaderBoxCasamento v-if="habilitacao.registro_id"
                                  info-title="Cônjuge 1"
                                  :info-name="habilitacao.registro.pessoas[0].nome_antigo"
                                  :info-cpf="habilitacao.registro.pessoas[0].cpf | cpf" />
            </b-row>

            <b-row>
              <HeaderBoxCasamento v-if="habilitacao.registro_id"
                                  info-title="Cônjuge 2"
                                  :info-name="habilitacao.registro.pessoas[1].nome_antigo"
                                  :info-cpf="habilitacao.registro.pessoas[1].cpf | cpf" />
            </b-row>
            <b-row>
              <HeaderBoxResume v-if="habilitacao.registro_id"
                               :info="habilitacao.registro.data_ocorrido | date"
                               text="Data do ocorrido" />
              <HeaderBoxResume v-if="habilitacao.registro_id"
                               :info="habilitacao.registro.data_registro | date"
                               text="Data de registro" />
              <HeaderBoxResume v-if="habilitacao.registro_id"
                               class="matricula_id"
                               :info="habilitacao.registro.matricula | maskMatricula"
                               text="Matrícula" />
            </b-row>
          </b-col>
        </b-row>
      </h4>
    </header-blue>

    <div class="Resumo EdicaoHabilitacaoCasamento">
      <b-tabs content-class="mt-2"
              class="Resumo-border"
              align="left"
              active-nav-item-class="Resumo--tab-active">
        <b-tab @click="tabIndex = 0">
          <template v-slot:title>
            Cônjuge 1
          </template>

          <conjugue :prop-pessoa="habilitacao.registro.pessoas[0]"
                    :prop-ordem="0"
                    :prop-habilitacao="habilitacao"
                    :prop-cartorio="dadosCartorio"
                    :prop-componente-pai="$options.name"
                    @onChange="onChangeConjugue"
                    @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab @click="tabIndex = 1">
          <template v-slot:title>
            Cônjuge 2
          </template>

          <conjugue :prop-pessoa="habilitacao.registro.pessoas[1]"
                    :prop-ordem="1"
                    :prop-habilitacao="habilitacao"
                    :prop-cartorio="dadosCartorio"
                    :prop-componente-pai="$options.name"
                    @onChange="onChangeConjugue"
                    @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab @click="tabIndex = 2">
          <template v-slot:title>
            Dados do Casamento
          </template>

          <dados-casamento :prop-habilitacao="habilitacao"
                           :prop-registro="habilitacao.registro"
                           :prop-cartorio="dadosCartorio"
                           :prop-edicao="true"
                           :prop-tab="tabIndex"
                           @onChange="onChangeDadosCasamento"
                           @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab v-if="habilitacao.tipo_casamento !== EDITAL_OUTRA_SERVENTIA"
               @click="tabIndex = 3">
          <template v-slot:title>
            Impressão das Peças
          </template>

          <impressao-pecas v-if="tabIndex == 3"
                           :prop-registro="true"
                           :prop-habilitacao="habilitacao"
                           :prop-tab="tabIndex"
                           @onChangeDeclaracao="onChangeDeclaracao" />
        </b-tab>

        <b-tab @click="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? tabIndex = 3 : tabIndex = 4">
          <template v-slot:title>
            Preparar Processo
          </template>

          <preparar-processo :prop-documentos="habilitacao.documentos"
                             :prop-tipo-documento="habilitacao.tipo_casamento"
                             :prop-habilitacao="habilitacao"
                             :prop-tab="tabIndex"
                             @onEditDoc="editarDocumento"
                             @onDeleteDoc="excluirDocumento"
                             @onDeleteds="changeDeleteds"
                             @onNewDocument="novoDocumento" />
        </b-tab>

        <b-tab @click="habilitacao.tipo_casamento === EDITAL_OUTRA_SERVENTIA ? tabIndex = 4 : tabIndex = 5">
          <template v-slot:title>
            Habilitação
          </template>

          <habilitacao :prop-registro="habilitacao.registro"
                       :prop-tab="tabIndex"
                       :prop-tipo-casamento="habilitacao.tipo_casamento"
                       :prop-habilitacao="habilitacao"
                       @onEmitChange="changeHabilitacao" />
        </b-tab>
      </b-tabs>
    </div>

    <hr>
    <div class="row mt-2">
      <div class="col">
        <ExcluirCancelarRegistro v-if="habilitacao && habilitacao.registro_id"
                                 :registro-id="habilitacao.registro_id" />
      </div>
      <div class="col text-right">
        <button id="btn-submit-cancel"
                class="btn btn-sm btn-dark"
                @click="$router.push({ name: 'resumo_habilitacao_casamento', params: { id: $route.params.id }})">
          Voltar
        </button>

        <button id="btn-submit-registro"
                class="btn btn-sm btn-secondary ml-2"
                @click="atualizaraHabilitacao">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import Conjugue from "@/components/SofiaRei/HabilitacaoCasamento/Conjugue"
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import HeaderBoxCasamento from "@/components/SofiaRei/Busca/HeaderBoxCasamento"
  import DadosCasamento from "@/components/SofiaRei/HabilitacaoCasamento/DadosCasamento"
  import ImpressaoPecas from "@/components/SofiaRei/HabilitacaoCasamento/ImpressaoPecas"
  import PrepararProcesso from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso"
  import Habilitacao from "@/components/SofiaRei/HabilitacaoCasamento/Habilitacao"
  import ExcluirCancelarRegistro from '@/components/SofiaRei/ExcluirCancelarRegistro'

  /* services */
  import HabilitacaoService from "@/services/Registros/Habilitacao"
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"

  /* others */
  import moment from "moment"
  import { mapGetters } from "vuex"

  /* constants */
  import { EDITAL_OUTRA_SERVENTIA } from "@/constants/casamento/tipos"

  export default {
    name: "EditarHabilitacaoCasamento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      HeaderBoxCasamento,
      Conjugue,
      DadosCasamento,
      ImpressaoPecas,
      PrepararProcesso,
      Habilitacao,
      ExcluirCancelarRegistro
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        EDITAL_OUTRA_SERVENTIA,
        show: true,
        tabIndex: 0,
        deleteds: {
          partes: [],
          genitores: [],
          pessoaDocumentos: [],
          registrosAnteriores: [],
          habilitacaoDocumentos: [],
          pessoaEnderecos: []
        },
        habilitacaoBkp: {},
        habilitacao: {
          documentos: [],
          tipo_casamento: null,
          regime_bens: null,
          casamento_em_cartorio: false,
          registro: {
            cartorio_id: this.$store.state.auth.cartorio_id,
            tipo_registro: "D", // Habilitação de Casamento - Proclamas
            data_ocorrido: null,
            hora_ocorrido: null,
            data_registro: null,
            partes: [],
            pessoas: [
              {
                endereco: {},
                genitores: [],
                registrosAnteriores: [],
                documentos: []
              },
              {
                endereco: {},
                genitores: [],
                registrosAnteriores: [],
                documentos: []
              }
            ],
            local: {
              descricao: null,
              endereco: {
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                cidade: null,
                uf: null,
                codigo_ibge_id: null
              }
            }
          },
          ...this.propHabilitacao
        },
        dadosCartorio: {},
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    created () {
      this.habilitacao.registro.cartorio_id = this.$store.state.auth.cartorio_id
    },
    async beforeMount () {
      await this.getCartorio()
      await this.init()
      this.controlEvent().addEvent()
    },
    methods: {
      async init () {
        try {
          loader({ text: "Carregando Habilitação de Casamento...", active: true })

          this.habilitacao = Object.values(this.propHabilitacao).length ? this.propHabilitacao : await HabilitacaoService.getHabilitacaoById(this.$route.params.id, this.$store.state.auth.cartorio_id)
          this.registro_id = this.habilitacao.registro_id

          this.habilitacao = {
            ...this.habilitacao,
            data_entrada: moment(this.habilitacao.data_entrada).format('YYYY-MM-DD'),
            data_habilitacao: moment(this.habilitacao.data_habilitacao).format('YYYY-MM-DD'),
            data_expiracao: moment(this.habilitacao.data_expiracao).format('YYYY-MM-DD'),
            data_casamento: this.habilitacao.data_casamento ? moment(this.habilitacao.data_casamento).format('YYYY-MM-DD') : null
          }
        } catch (e) {
          if (!this.registro_id || (e.response && e.response.status === 404)) {
            this.$router.push('/pagina-nao-encontrada')
          }
        } finally {
          // guardamos um bkp da habilitacao original
          this.habilitacaoBkp = Object.assign({}, { ...this.habilitacao })
          loader({ active: false})
        }
      },
      async atualizaraHabilitacao () {
        const menores = []

        this.habilitacao.registro.pessoas.forEach(pessoa => {
          if (pessoa.idade && pessoa.idade < 16) {
            menores.push(pessoa.nome_antigo)
          }
        })

        if (menores.length) {
          const resp = await displayMessage('question', 'Alerta!', `Existem contraentes com idade inferior a 16 anos. Tem certeza que deseja continuar?`)

          if (!resp.value) {
            return
          }
        }

        let swalQuestion = { ...objSwal.question }
        swalQuestion.title = "Confirmar atualização?"
        swalQuestion.text = ""
        swalQuestion.cancelButtonText = "Não"
        swalQuestion.confirmButtonText = "Sim"
        Swal.fire(swalQuestion).then(async status => {

          if (status.value === true || status.dismiss == "cancel") {
            tratarHabilitacao()

            try {
              this.show = false
              loader({ text: "Atualizando Habilitação...", active: true })

              if (status.value === true) {
                const errors = this.verifyInputs()

                if (errors.length) {
                  this.showErrorList(errors)
                } else {
                  const { params: { id } } = this.$route

                  const habilitacaoAtualizada = await HabilitacaoService.updateHabilitacao(this.habilitacao, id)

                  // Caso o tipo de casamento for diferente, mandamos a prop como true.
                  // Mas somente vai mandar para o memorial aditivo, se o usuário clicar em Não, no swal que confirma se quer gerar autuação.
                  const route = { name: 'resumo_habilitacao_casamento', params: { id, propImpressaoMemorialAditivo: habilitacaoAtualizada.tipo_casamento !== this.habilitacaoBkp.tipo_casamento }}
                  this.$router.push(route)
                }
              }

              this.show = true
            } catch (e) {
              objSwal.error.title = "Erro ao atualizar."
              objSwal.error.text = ''
              Swal.fire(objSwal.error)
              console.error('Erro ao atualizar Habilitação', e)
            } finally {
              loader({ active: false })
            }

          }

        })

        const tratarHabilitacao = () => {
          const habilitacao = { ...this.habilitacao }
          const { deleteds } = this

          habilitacao.registro.pessoas.map(pessoa => {
            pessoa.nome_novo = pessoa.novo_nome
          })

          Object.assign(this.habilitacao, { deleteds })
        }
      },
      previousActive () {
        window.scrollTo({top: 0, behavior: 'smooth'})
        this.wizard.ativo--
      },
      onChangeDadosCasamento (habilitacao) {
        Object.assign(this.habilitacao, habilitacao)
      },
      onChangeConjugue (conjugue) {
        if (conjugue && this.habilitacao.registro.pessoas[conjugue.ordem]) {
          Object.assign(this.habilitacao.registro.pessoas[conjugue.ordem], conjugue.pessoa)
        }
      },
      onChangeDeclaracao (declaracao) {
        this.habilitacao.declaracao_pobreza = declaracao
      },
      novoDocumento (documento) {
        if (documento.length > 0) {
          this.habilitacao.documentos = documento
        }
      },
      editarDocumento (documento) {
        let doc = this.habilitacao.documentos.find((doc) => doc.url_s3 == documento.url_s3)
        doc.tag = documento.tag
        doc.tipo_documento = documento.tipo_documento
        doc.correspondente = documento.correspondente
      },
      async excluirDocumento (documento) {
        const docs = this.habilitacao.documentos.filter((doc) => doc.url_s3 != documento.url_s3)
        this.habilitacao.documentos = [ ...docs ]

        // apagamos o pdf
        if (!documento.habilitacao_casamento_documento_id) {
          await UploadTemporarioService.deleteTemporario(documento.url_s3)
        }
      },
      changeHabilitacao (registro) {
        Object.assign(this.habilitacao.registro, registro)
      },
      changeDeleteds (deleted) {
        const key = Object.keys(deleted)[0]
        this.deleteds[key].push(deleted[key])
      },
      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-registro')
            const btnCancel = document.querySelector('#btn-cancel-registro')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })

              abas[0].focus()
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1) {
            setTimeout(() => {
              abas[index + 1].focus()
              abas[index + 1].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          } else if (index != -1 && index == abasArr.length - 1) {
            setTimeout(() => {
              abas[index].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const btnSubmit = document.querySelector('#btn-submit-registro')

          if (abas) {
            if (event.target.id == 'btn-cancel-registro' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-registro') {
              setTimeout(() => {
                abas[0].focus()
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      },
      //Verificando campos obrigatorios
      verifyInputs () {
        const messageErrors = []
        
        const semHoraData = [
          'Afixação de edital de outra serventia',
          'Casamento Religioso com efeito civil',
          'Conversão de união estável em casamento'
        ]

        if (!this.habilitacao.registro.escrevente) {
          messageErrors.push('Informe o escrevente do registro')
        }
        if (!this.habilitacao.registro.digitador) {
          messageErrors.push('Informe o digitador do registro')
        }
        if (!this.habilitacao.registro.pessoas[0].nome_antigo || !this.habilitacao.registro.pessoas[1].nome_antigo ) {
          this.habilitacao.registro.pessoas.forEach((pessoa, index) => {
            if (!pessoa.nome_antigo) {
              messageErrors.push(`Informe o nome do cônjuge ${index + 1}`)
            }
          })
        }
        if ((!!this.habilitacao.registro.pessoas[0].data_nascimento && this.habilitacao.registro.pessoas[0].idade < 14) || this.habilitacao.registro.pessoas[0].data_nascimento > this.limitDate ) {
          messageErrors.push(`Data de nascimento do cônjuge 1 inválida`)
        }
        if ((!!this.habilitacao.registro.pessoas[1].data_nascimento && this.habilitacao.registro.pessoas[1].idade < 14) || this.habilitacao.registro.pessoas[1].data_nascimento > this.limitDate ) {
          messageErrors.push(`Data de nascimento do cônjuge 2 inválida`)
        }
        if (!this.habilitacao.tipo_casamento) {
          messageErrors.push('Informe o tipo de Casamento')
        }
        if (!this.habilitacao.data_casamento && !semHoraData.includes(this.habilitacao.tipo_casamento)) {
          messageErrors.push('Informe a data do Casamento')
        }
        if (!this.habilitacao.hora_casamento && !semHoraData.includes(this.habilitacao.tipo_casamento)) {
          messageErrors.push('Informe a hora do Casamento')
        }
        if (!this.habilitacao.data_entrada) {
          messageErrors.push('Informe a data de entrada')
        }
        if (!this.habilitacao.data_expiracao) {
          messageErrors.push('Informe a data de expiração')
        }
        if (!this.habilitacao.data_habilitacao) {
          messageErrors.push('Informe a data de habilitação')
        }
        if (!this.habilitacao.registro.folha) {
          messageErrors.push('Informe o número da folha')
        }
        if (!this.habilitacao.registro.livro.num_livro) {
          messageErrors.push('Informe o número do livro')
        }
        if (!this.habilitacao.registro.termo) {
          messageErrors.push('Informe o número do registro')
        }

        return messageErrors
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar Habilitação'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
    }
  }
</script>

<style lang="scss">
  @import "./src/scss/_components/resumos";
  .headerBlueEdicao{
    height: 215px;
  }
  .habilitacaoTitle{
    position: relative;
    top:95px;
    height: 10%;
  }
  .headerEditHabilitacao{
    position: relative;
    right: 40px;
  }
</style>
